import { render, staticRenderFns } from "./abnormalModalView.vue?vue&type=template&id=582e24ba&scoped=true&"
import script from "./abnormalModalView.vue?vue&type=script&lang=js&"
export * from "./abnormalModalView.vue?vue&type=script&lang=js&"
import style0 from "./abnormalModalView.vue?vue&type=style&index=0&id=582e24ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582e24ba",
  null
  
)

export default component.exports